<template>
  <modal-pop
    :opened.sync="appExitModalOpended"
    :no-negative-button="true"
    confirm="MCOM-0000006"
    cancel="MCOM-0000005"
    @confirm="appExit"
  >
    <template #content>
      <strong class="text-info">{{ /*KB Global 앱을 종료하시겠습니까?*/ $t("MMAIN-03-01-01-18") }}</strong>
    </template>
  </modal-pop>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["appExitModalOpended"]),
  },
  methods: {
    appExit() {
      this.$bridge.exitApp();
    },
  },
};
</script>